export const MAX_LENGTH = 7;
export const TEST_CODE_INIT = '___-___';
export const TEST_LAUNCH_RESULT = 'TestLaunchResult';